import(/* webpackMode: "eager", webpackExports: ["CookiebotProvider","CookiebotScript"] */ "/home/circleci/project/frontend/app/components/CookiebotScript/CookiebotScript.tsx");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/frontend/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ConfigProvider"] */ "/home/circleci/project/frontend/app/providers/ConfigProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/circleci/project/frontend/app/providers/SearchBarProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/circleci/project/frontend/app/providers/ToastProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/circleci/project/frontend/app/providers/TranslationsProvider.tsx");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/frontend/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/frontend/node_modules/next/font/google/target.css?{\"path\":\"app/utils/fonts.ts\",\"import\":\"Rubik\",\"arguments\":[{\"subsets\":[\"cyrillic-ext\"],\"preload\":false}],\"variableName\":\"rubik\"}");
